export default "/sun-up.14232ad6-6c24a2.png";